<template>
  <app-modal modal-alignment="top" modal-id="museum-modal" modal-size="default" @close-modal="closeModal">
    <template slot="header">
      <h5 class="modal-title">{{ selectedUrl ? $t('edit') : $t('add') }}</h5>
      <button aria-label="Close" class="close outline-none" data-dismiss="modal" type="button">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <form ref="form" :data-url="selectedUrl ? selectedUrl : `crm/museum/store`">
        <div class="form-group">
          <label>{{ $t('name') }}</label>
          <app-input v-model="formData.name" :placeholder="$t('enter_name')" :required="true" />
          <span v-if="errors.name" class="text-danger">{{ errors.name[0] }}</span>
        </div>
        <div class="form-group">
          <label>{{ $t('address') }}</label>
          <app-input v-model="formData.address" :placeholder="$t('enter_address')" :required="true" />
          <span v-if="errors.address" class="text-danger">{{ errors.address[0] }}</span>
        </div>
        <div class="form-group">
          <label>{{ $t('currency') }}</label>
          <app-input v-model="formData.currency_id" :list="currencyList" list-value-field="iso"
            :placeholder="$t('select_currency')" type="select" @input="setCurrency($event)" :required="true" />
          <span v-if="errors.currency_id" class="text-danger">{{ errors.currency_id[0] }}</span>
        </div>


      </form>
    </template>
    <template slot="footer">
      <button class="btn btn-secondary mr-2" data-dismiss="modal" type="button" @click.prevent="closeModal">{{
        $t('cancel') }}
      </button>
      <button class="btn btn-primary" type="button" @click.prevent="submitData">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t('save') }}</template>
      </button>
    </template>
  </app-modal>
</template>

<script>

import { FormMixin } from "../../../../core/mixins/form/FormMixin.js";
import { mapGetters } from "vuex";

export default {
  name: "CustomFieldModal",
  mixins: [FormMixin],
  props: {
    tableId: String,
    selectedUrl: String,
    currencyList: Array,
  },
  data() {
    return {
      formData: {
        name: "",
        address: "",
        currency_id: null,
      },
      errors: [],
      loading: false,
    };
  },
  computed: {

  },
  methods: {
    beforeSubmit() {
      this.loading = true;
    },
    submitData() {
      this.save(this.formData)
    },
    afterSuccessFromGetEditData({ data }) {
      this.formData.name = data.name;
      this.formData.address = data.address;
      this.formData.currency_id = data.currency_id;
    },

    afterError(response) {
      this.loading = false;
      this.errors = response.data.errors;
    },

    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      $("#museum-modal").modal("hide");

      setTimeout(() => {

        this.closeModal();

      }, 300);
    },

    afterFinalResponse() {
      this.loading = false;
    },
    setCurrency(currency_id) {
      this.formData.currency_id = currency_id;
    },
    closeModal(value) {
      this.$emit("close-modal", value);
    },
  },

  mounted() {
  },
};
</script>
